import React, { useState } from "react";
import { Flex } from "@mantine/core";
import { MouseEvent } from "react";

import {
  IconDeviceFloppy,
  IconCircleCheck,
  IconCircleX,
  IconDownload,
  IconEdit,
  IconFilePlus,
  IconHierarchy2,
  IconInfoCircle,
  IconSignature,
  IconTrash,
  IconUser,
  IconUserCheck,
  IconUserCog,
  IconUsers,
  IconXboxX,
  IconX,
  IconArrowsVertical,
  IconSquareRoundedPlus,
  IconArrowsMinimize,
  IconArrowsMaximize,
  IconCopy,
  IconFiles,
  IconHierarchy,
  IconCirclePlus,
  IconUserCircle,
  IconLayoutGrid,
  IconLayoutGridAdd,
  IconFile,
  IconLayoutGridRemove,
  IconArrowLeft,
  IconDotsVertical,
  IconLicense,
  IconCheck,
  IconArrowBackUp,
  IconSettings,
  IconArrowNarrowRight,
  IconUserShare,
  IconFileSearch,
  IconFileUpload,
  IconEye,
  IconSquareFilled,
  IconLayoutNavbar,
  IconChevronRight,
  IconChevronLeft,
  IconCancel,
  IconCalendarDue,
  IconBell,
  IconFileText,
  IconNotes,
  IconAlertCircle,
  IconGift,
  IconShield,
  IconListCheck,
  IconParkingCircle,
  IconClipboardText,
  IconMoodSmileBeam,
  IconBulb,
  IconHeartFilled,
  IconMaximize,
  IconMinimize,
  IconMoon,
  IconSun,
  IconRefresh,
  IconCircleFilled,
  IconPhoneCall,
  IconAt,
  IconSortAscending,
  IconSortDescending,
  IconTable,
  IconDots,
  IconFolder,
  IconLetterT,
  IconLockCode,
  IconSwitchHorizontal,
  IconLogout,
  IconBriefcase,
  IconCalendar,
  IconTree,
  IconPlus,
  IconPointFilled,
  IconUserFilled,
  IconLogin2,
  IconFilter,
  IconUpload,
  IconTemperature,
  IconBabyCarriage,
  IconMoodSick,
  IconEmergencyBed,
  IconTournament,
  IconHome,
  IconMoneybagMoveBack,
  IconDoorExit,
  IconFileCode2,
  IconCpu,
  IconClockHour4,
  IconArrowUpRight,
  IconMail,
  IconTag,
  IconBuildings,
  IconBuilding,
  IconDeviceDesktop,
  IconSquareLetterP,
  IconDeviceLaptop,
  IconArrowGuide,
  IconMenu2,
  IconShieldLock,
  IconCircle,
  IconArrowNarrowLeft,
  IconClipboardCheck,
  IconInbox,
  IconBallpen,
  IconChevronDown,
  IconUserPlus,
  IconExclamationCircle,
  IconStack2,
  IconActivity,
  IconSquarePlus,
  IconChevronUp,
  IconCameraUp,
  IconSearch,
  IconTarget,
  IconMessageCircle,
  IconRoute
} from "@tabler/icons-react";
import CustomTooltip from "../CustomTooltip/CustomTooltip";
import { clickableColorOutline } from "../../mantineReactTable/sizes";

interface CustomIconProps {
  iconType: string;
  onClick?: () => void;
  onClickRadioButton?: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  size?: number | string;
  style?: React.CSSProperties;
  label?: string | React.ReactNode;
  color?: string;
  hoverColor?: string;
  editProjectData?: string;
  isCardView?: boolean;
  w?: string | number;
  h?: string | number;
  isHoveredIcons?: boolean;
  withBox?: boolean;
  boxW?: number | string;
  boxH?: number | string;
  boxPt?: number | string;
  stroke?: number;
}

const CustomIcon = ({
  iconType,
  onClick,
  size,
  style,
  label,
  color,
  hoverColor,
  editProjectData,
  isCardView,
  w,
  h,
  isHoveredIcons,
  withBox,
  boxH,
  boxW,
  boxPt,
  stroke = 1
}: CustomIconProps) => {
  // const { colorScheme } = useMantineColorScheme();
  const sizeMapping: { [key: string]: number } = {
    sm: 16,
    md: 20,
    lg: 24,
    xl: 32,
  };

  const resolvedSize = typeof size === "string" ? sizeMapping[size] ?? 20 : size ?? 20;
  const [localHovered, setLocalHovered] = useState(false);

  // Use parent-controlled hover state if provided, otherwise use local state
  const isHovered = isHoveredIcons !== undefined ? isHoveredIcons : localHovered;

  // Box wrapper styling logic
  // const isDark = colorScheme === 'dark';
  // const bgColor = isDark ? '#2C2E33' : 'white';
  const boxStyle = {
    borderRadius: '6px',
    display: 'flex',
    alignItems: 'center',
    border: '.75px solid #e2e8f0',
    cursor: 'pointer',
    background: '#f8fafc'
  };


  const hovercolor = hoverColor || clickableColorOutline;
  const defaultcolor = color || 'gray';
  const deleteorcancel = "red";
  const width = isCardView ? '1.2rem' : w || '1.2rem';
  const height = isCardView ? '1.2rem' : h || '1.2rem';
  const cursor = 'pointer';
  // const stroke = 1;
  const strokeWidth = isCardView ? 1 : stroke;
  let iconBoxBg = '#f8fafc';


  if (iconType === "delete" || iconType === "cancel" || iconType === "xboxX" || iconType === "Sun") {
    iconBoxBg = isHovered ? '#fef2f2' : '#f8fafc';
  }
  else {
    iconBoxBg = isHovered ? '#f0f7ff' : '#f8fafc';
  }

  //   useEffect(() => {
  //     const newColor = computedColorScheme === 'dark' ? 'var(--mantine-color-dark-5)' : 'var(--mantine-color-gray-1)';
  //     setColor(newColor);
  //     document.documentElement.style.setProperty('--dynamic-color', newColor);
  //   }, [computedColorScheme]);

  //   return color;
  // };

  const getIcon = () => {
    const handleMouseEnter = () => {
      if (isHoveredIcons === undefined) {
        setLocalHovered(true);
      }
    };

    const handleMouseLeave = () => {
      if (isHoveredIcons === undefined) {
        setLocalHovered(false);
      }
    };

    const commonProps = {
      size: resolvedSize,
      style: { width: width, height: height, cursor: cursor, ...style },
      stroke: stroke,
      ...(!withBox && { onClick }),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      strokeWidth: strokeWidth,
    };

    const commonPropsFile = {
      size: resolvedSize,
      style: { width: width, height: height, cursor: cursor, ...style },
      stroke: stroke,
      ...(!withBox && { onClick }),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      strokeWidth: strokeWidth,
    };

    // const configProps = {
    //   size: resolvedSize,
    //   style: { width: width, height: height, cursor: cursor, ...style },
    //   stroke: stroke,
    //   onMouseEnter: handleMouseEnter,
    //   onMouseLeave: handleMouseLeave,
    //   strokeWidth: strokeWidth,
    // };
    const disableProps = {
      size: resolvedSize,
      style: { width: width, height: height, cursor: cursor, ...style },
      stroke: stroke,
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      strokeWidth: strokeWidth,
    };
    const emailProps = {
      size: resolvedSize,
      style: { width: width, height: height, cursor: cursor, ...style },
      stroke: stroke,
      ...(!withBox && { onClick }),
      onMouseEnter: handleMouseEnter,
      onMouseLeave: handleMouseLeave,
      strokeWidth: strokeWidth,
    };

    switch (iconType) {
      case "save":
        return <IconDeviceFloppy color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "approve":
        return (
          <IconCircleCheck color={isHovered ? "var(--mantine-color-green-filled)" : defaultcolor} {...commonProps} />
        );
      case "reject":
        return <IconCircleX color={isHovered ? deleteorcancel : defaultcolor} {...commonProps} />;
      case "download":
        return <IconDownload color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "edit":
        return <IconEdit color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "addDocument":
        return <IconFilePlus color={isHovered ? "var(--mantine-color-green-filled)" : defaultcolor} {...commonProps} />;
      case "viewHierarchy":
        return <IconHierarchy2 color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "info":
        return <IconInfoCircle color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "inbox":
        return <IconInbox color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "signature":
        return <IconSignature color={color} {...commonProps} />;
      case "delete":
        return <IconTrash color={isHovered ? deleteorcancel : defaultcolor} {...commonProps} />;
      case "user":
        return <IconUser color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "userCheck":
        return <IconUserCheck color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "userCog":
        return <IconUserCog color={isHovered ? "var(--mantine-color-green-filled)" : defaultcolor} {...commonProps} />;
      case "users":
        return <IconUsers color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "xboxX":
        return <IconXboxX color={isHovered ? deleteorcancel : defaultcolor} {...commonProps} />;
      case "disableDelete":
        return <IconTrash color={isHovered ? deleteorcancel : defaultcolor} {...disableProps} />;
      case "cancelX":
        return <IconX color={isHovered ? deleteorcancel : defaultcolor} {...commonProps} />;
      case "cross":
        return <IconX color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "expand":
        return <IconArrowsVertical color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "previews":
        return <IconEye color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "letsDoIt":
        return <IconChevronRight color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "smiley":
        return <IconMoodSmileBeam color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "bulb":
        return <IconBulb color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "heart":
        return <IconHeartFilled color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "refetch":
        return <IconRefresh color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "maternity":
        return <IconBabyCarriage color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "sick":
        return <IconMoodSick color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "emergency":
        return <IconEmergencyBed color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "compensatory":
        return <IconTournament color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "workfromhome":
        return <IconHome color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "earned":
        return <IconMoneybagMoveBack color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "generalleave":
        return <IconDoorExit color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "envelope":
        return <IconFileCode2 color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "userPlus":
        return <IconUserPlus color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      // case "ConfigEdit":
      //   return (
      //     <IconEdit
      //       color={isHovered ? hovercolor : defaultcolor}
      //       onClick={(event: MouseEvent<SVGSVGElement>) => {
      //         onClickRadioButton?.(event);
      //       }}
      //       {...configProps}
      //     />
      //   );
      // case "ConfigDelete":
      //   return (
      //     <IconTrash
      //       color={isHovered ? deleteorcancel : defaultcolor}
      //       onClick={(event: any) => {
      //         onClickRadioButton?.(event);
      //       }}
      //       {...configProps}
      //     />
      //   );
      case "AddData":
        return <IconSquareRoundedPlus color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "ProjectTick":
        return (
          <IconCircleCheck color={isHovered ? "var(--mantine-color-green-filled)" : defaultcolor} {...commonProps} />
        );
      case "ProjectSaved":
        return (
          <IconCircleCheck
            color={isHovered ? "var(--mantine-color-green-filled)" : "var(--mantine-color-green-filled)"}
            {...commonProps}
          />
        );
      case "editProject":
        return <IconCircleCheck color={isHovered ? hovercolor : defaultcolor} {...disableProps} />;
      case "expandAll":
        return <IconArrowsMaximize color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "collapseAll":
        return <IconArrowsMinimize color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Copy":
        return <IconCopy color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Temparature":
        return <IconTemperature color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "PalmTree":
        return <IconTree color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "TickCopy":
        return <IconCopy color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "IconFiles":
        return <IconFiles color={isHovered ? hovercolor : defaultcolor} {...commonPropsFile} />;
      case "IconHierarchy":
        return <IconHierarchy color={isHovered ? hovercolor : defaultcolor} {...commonPropsFile} />;
      case "IconCirclePlus":
        return <IconCirclePlus color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "itemToResours":
        return <IconUserCircle color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "view":
        return <IconLayoutGrid color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "viewTwo":
        return <IconLayoutGridAdd color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "viewThree":
        return <IconLayoutGridRemove color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "table":
        return <IconTable color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "IconFile":
        return <IconFile color={isHovered ? hovercolor : defaultcolor} {...commonPropsFile} />;
      case "IconArrowLeft":
        return <IconArrowLeft color={isHovered ? hovercolor : defaultcolor} {...commonPropsFile} />;
      case "IconDotsVertical":
        return <IconDotsVertical color={isHovered ? hovercolor : defaultcolor} {...commonPropsFile} />;
      case "IconDots":
        return <IconDots color={isHovered ? hovercolor : defaultcolor} {...commonPropsFile} />;
      case "emailProps":
        return <IconEdit color={isHovered ? hovercolor : defaultcolor} {...emailProps} />;
      case "emaildelete":
        return <IconTrash color={isHovered ? deleteorcancel : defaultcolor} {...emailProps} />;
      case "note":
        return <IconLicense color={isHovered ? hovercolor : defaultcolor} {...commonPropsFile} />;
      case "recall":
        return <IconArrowBackUp color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "approved":
        return <IconCheck color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "settings":
        return <IconSettings color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "arrowRight":
        return <IconArrowNarrowRight color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "issue":
        return <IconUserShare color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "preview":
        return <IconFileSearch color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "upload":
        return <IconFileUpload color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "camera":
        return <IconCameraUp color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "dot":
        return <IconSquareFilled size={5} radius={'50%'} style={{ color: color, borderRadius: '50%', }} />;
      case "navbar":
        return <IconLayoutNavbar color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "right":
        return <IconChevronRight color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "up":
        return <IconChevronUp color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "left":
        return <IconChevronLeft color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "cancel":
        return <IconCancel color={isHovered ? deleteorcancel : defaultcolor} {...commonProps} />;
      case "date":
        return <IconCalendarDue color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Notification":
        return <IconBell color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Documents":
        return <IconFileText color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Projects":
        return <IconParkingCircle color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Notes":
        return <IconNotes color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Alerts":
        return <IconAlertCircle color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Celebrations":
        return <IconGift color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Updates":
        return <IconShield color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Tasks":
        return <IconListCheck color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Reports":
        return <IconClipboardText color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "SmileBeam":
        return <IconMoodSmileBeam color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Maximize":
        return <IconMaximize color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Minimize":
        return <IconMinimize color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "Sun":
        return <IconSun color={isHovered ? deleteorcancel : defaultcolor} {...commonProps} />;
      case "Moon":
        return <IconMoon color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "CircleFilled":
        return <IconCircleFilled color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "CircleOutline":
        return <IconCircle color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "IconAt":
        return <IconAt color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "phone":
        return <IconPhoneCall color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "asc":
        return <IconSortAscending color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "dsc":
        return <IconSortDescending color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "tab":
        return <IconFolder color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;
      case "t":
        return <IconLetterT color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "lock":
        return <IconLockCode color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "switch":
        return <IconSwitchHorizontal color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "Briefcase":
        return <IconBriefcase color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "Calendar":
        return <IconCalendar color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "Plus":
        return <IconPlus color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "PointFilled":
        return <IconPointFilled color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "logout":
        return <IconLogout color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "userFilled":
        return <IconUserFilled color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "login":
        return <IconLogin2 color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "filter":
        return <IconFilter color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "uploadfile":
        return <IconUpload color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "workflowstep":
        return <IconCpu color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "time":
        return <IconClockHour4 color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "arrowupright":
        return <IconArrowUpRight color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "mail":
        return <IconMail color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "tag":
        return <IconTag color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "building":
        return <IconBuildings color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "company":
        return <IconBuilding color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "deviceDesktop":
        return <IconDeviceDesktop color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "SquareLetterP":
        return <IconSquareLetterP color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "laptop":
        return <IconDeviceLaptop color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "tracking":
        return <IconArrowGuide color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "Menu":
        return <IconMenu2 color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "Security":
        return <IconShieldLock color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "BackArrow":
        return <IconArrowNarrowLeft color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "Review":
        return <IconClipboardCheck color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "BallPen":
        return <IconBallpen color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "chevronDown":
        return <IconChevronDown color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "exclmationCircle":
        return <IconExclamationCircle color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "stack":
        return <IconStack2 color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "activity":
        return <IconActivity color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "sqaurePlus":
        return <IconSquarePlus color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "Search":
        return <IconSearch color={isHovered ? hovercolor : defaultcolor} {...commonProps} />

      case "Target":
        return <IconTarget color={isHovered ? hovercolor : defaultcolor} {...commonProps} />

      case "Message":
        return <IconMessageCircle color={isHovered ? hovercolor : defaultcolor} {...commonProps} />
      case "workflow":
        return <IconRoute color={isHovered ? hovercolor : defaultcolor} {...commonProps} />;

      default:
        return null;
    }
  };

  const renderIcon = (): React.ReactElement => {
    if (editProjectData) {
      return <span>{getIcon() ?? <></>}</span>;
    }
    return (
      <CustomTooltip label={label || ""}>
        <span>{getIcon()}</span>
      </CustomTooltip>
    );
  };
  const [hovered, setHovered] = useState(false);

  const getIconWithWrapper = (): React.ReactElement => {
    switch (true) {
      case withBox:
        return (
          <Flex justify={'center'}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            align={'center'} bg={hovered ? iconBoxBg : '#f8fafc'} w={boxW || 35} h={boxH || 35} pt={boxPt || 5} style={boxStyle} onClick={onClick}>
            {renderIcon()}
          </Flex>
        );
      default:
        return renderIcon();
    }
  };

  return getIconWithWrapper();
};
export default CustomIcon;
